module.exports = __webpack_public_path__ + "img/wenzi3.0dfc9c2a.svg";